module.exports = "//static.hsappstatic.net/ContentUtils/static-1.59737/img/choiceButtons/social-icon-size-large.svg"